/* eslint-disable */ import { memoEval, sceneEntityAddFabComponent, sceneEntityDeleteFabComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const emptySpaceComponents = [
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addBaseCabinetFab', true).withEntity('EmptySpace').withGradualFilter({
        modes: [
            'owner'
        ]
    }).attach(memoEval(()=>[], ()=>({
            offsetX: 12,
            offsetY: 20,
            offsetZ: 12,
            instanceNames: [
                'baseCabinetWithoutCountertop'
            ],
            skipMenuWhenOnlyOne: true,
            hideWhenNone: true,
            showWhen: [
                'selected',
                'unselected'
            ],
            polarAngleLimits: {
                min: 1.4,
                max: 1.7
            },
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.3
            }
        }))),
    attachComponent.withComponent(sceneEntityDeleteFabComponent, 'emptySpace', true).withEntity('EmptySpace').withGradualFilter({
        modes: [
            'owner'
        ]
    }).attach(memoEval((self)=>[
            self.$fabCenteredOffsetX,
            self.$fabOffsetY
        ], ($fabCenteredOffsetX, $fabOffsetY)=>({
            offsetX: $fabCenteredOffsetX,
            offsetY: $fabOffsetY,
            offsetZ: 12,
            showWhen: [
                'selected',
                'unselected'
            ]
        })))
];

//# sourceMappingURL=empty-space.js.map